// EPOCH 35 - Phase 3: CSR Context Banner
// Shows when a CSR is acting on behalf of a user

import React from 'react';
import { useCSRContext } from '../../hooks/useCSRContext';

export const CSRContextBanner: React.FC = () => {
  const { isCSR, isActingAsUser, targetUser, clearContext } = useCSRContext();

  // Don't show banner if not a CSR or not acting as user
  if (!isCSR || !isActingAsUser || !targetUser) {
    return null;
  }

  return (
    <div className="bg-purple-600 text-white px-4 py-2 shadow-lg relative z-50">
      <div className="container mx-auto flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <span className="text-2xl">🎭</span>
          <div>
            <span className="font-semibold">Acting as: </span>
            <span className="font-bold">{targetUser.full_name || targetUser.email}</span>
            <span className="text-purple-200 ml-2">({targetUser.company_name})</span>
          </div>
        </div>
        <button
          onClick={clearContext}
          className="bg-purple-700 hover:bg-purple-800 px-4 py-1 rounded-lg transition-colors flex items-center space-x-2"
        >
          <span>✕</span>
          <span>Exit User Context</span>
        </button>
      </div>
    </div>
  );
};